/* eslint-disable no-param-reassign */

const instaGrids:Array<HTMLElement>|null = Array.from(document.querySelectorAll('.dstijl-insta-feed'));
const gridWrapper:HTMLElement = document.querySelector('.dstijl-grid-system__wrapper')!;

function getGridItems(feed:HTMLElement):Array<HTMLElement> {
  return Array.from(feed.querySelectorAll('.dstijl-grid-system__instaItem img'));
}

function getItemHeight(feedItem:HTMLElement) {
  return feedItem.offsetHeight;
}

function setInstaHeight(feed:HTMLElement) {
  const height = getItemHeight(getGridItems(feed)[0]);
  feed.style.height = `${height}px`;
  gridWrapper.style.gridAutoRows = 'auto';
}

function loopFeeds() {
  instaGrids?.forEach((instaFeed) => {
    setInstaHeight(instaFeed);
  });
}

if (instaGrids) {
  window.addEventListener('resize', loopFeeds);
  loopFeeds();
}
